
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { appEventBus } from "@/utilities/EventBus";
    import Colours from "@/utilities/Colours";

    @Component({})
    export default class ApiButton extends Vue {

        @Prop({ default: null }) private busyEventName!: string|null;

        mounted(): void {
            if(this.busyEventName != null) appEventBus.on(this.busyEventName, this.onBusy);
        }

        beforeDestroy(): void {
            if(this.busyEventName != null) appEventBus.off(this.busyEventName, this.onBusy);
        }

        get buttonColour(): string {
            const isDisabled = Boolean(this.$attrs["disabled"]);
            return isDisabled
                ? "#888"
                : this.$store.state.clientSettings?.client?.buttonColour ?? "#88F";
        }

        get isDark(): boolean {
            const isDisabled = Boolean(this.$attrs["disabled"]);
            return !isDisabled && Colours.isDark(this.buttonColour);
        }

        loading: boolean = false;

        onBusy(event: CustomEvent<any>) {
            console.log("⚡ button - onBusy", event.detail);
            this.loading = Boolean(event.detail);
        }

        // eslint-disable-next-line
        get listeners(): Record<string, Function | Function[]> {
            // we could add in our own custom listeners here
            return { ...this.$listeners };
        }
    }
